import React, { useState, useEffect, useRef, Fragment } from "react";
import AdminUserRoleService from "../../../API/Services/AdminService/AdminUserRoleService";
import { Link, useLocation, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import UserOffcanvas from "./UserOffcanvas";
import MainPagetitle from "../../layouts/MainPagetitle";
import { Col, Offcanvas, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ClipLoader from "react-spinners/ClipLoader";
import AccessField from "../../components/AccssFieldComponent/AccessFiled";
import ColumnReOrderPopup from "../../popup/ColumnReOrderPopup";
import BulkUserUpdateOffcanvas from "./BulkUserUpdateOffcanvas";
import Modal from "react-bootstrap/Modal";
import { MultiSelect } from "react-multi-select-component";
import Swal from "sweetalert2";
import DateComponent from "../../components/date/DateFormat";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { startImpersonationSession } from "../../../utils/impersonationSession";
import AdminSubscriberService from "../../../API/Services/AdminService/AdminSubscriberService";
import { updateStoredSubscriptionAccess } from "../../../utils/subscriptionAccess";

const UserList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = JSON.parse(queryParams.get("page")) === 1 ? null : JSON.parse(queryParams.get("page"));

  const navigate = useNavigate();
  const product = useRef();
  const bulkproduct = useRef();

  const [showSort, setShowSort] = useState(false);
  const handleSortClose = () => setShowSort(false);
  const [Error, setError] = useState("");
  const [userList, setUserList] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [userListCount, setUserCount] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 100;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const [npage, setNpage] = useState(0);
  const number = [...Array(npage + 1).keys()].slice(1);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const [UserDetails, setUserDetails] = useState({});
  const [UserSubscriptionDetails, setUserSubscriptionDetails] = useState({});
  const [UserCounts, setUserCounts] = useState({});
  const [userDetailTab, setUserDetailTab] = useState("personal");

  const handleUserDetailTabChange = (event, newValue) => {
    setUserDetailTab(newValue);
  };

  const clearPriceDetails = () => {
    setUserDetails({});
    setUserSubscriptionDetails({});
    setUserDetailTab("personal");
  };
  const [manageAccessOffcanvas, setManageAccessOffcanvas] = useState(false);
  const [accessList, setAccessList] = useState({});
  const [accessRole, setAccessRole] = useState("Admin");
  const [accessForm, setAccessForm] = useState({});
  const [role, setRole] = useState("Admin");
  const [checkedItems, setCheckedItems] = useState({}); // State to manage checked items
  const [manageAccessField, setManageAccessField] = useState(false);
  const [fieldList, setFieldList] = useState([]);

  // const fieldList = AccessField({ tableName: "users" });
  const [openDialog, setOpenDialog] = useState(false);
  const [columns, setColumns] = useState([]);
  const [draggedColumns, setDraggedColumns] = useState(columns);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [companyFilterName, setCompanyFilterName] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);

  const defaultSortConfigUsers = [
    { key: "company", direction: "asc" },
    { key: "last_name", direction: "asc" },
    { key: "name", direction: "asc" },
  ];

  const defaultSelectedFieldsUsers = [
    { value: "company", label: "Company" },
    { value: "last_name", label: "Last Name" },
    { value: "name", label: "First Name" },
  ];

  const defaultSelectionOrderUsers = {
    company: 1,
    last_name: 2,
    name: 3,
  };

  const defaultSortOrdersUsers = {
    company: "asc",
    last_name: "asc",
    name: "asc",
  };

  const [sortConfig, setSortConfig] = useState(() => {
    const savedSortConfig = localStorage.getItem("sortConfigUsers");
    return savedSortConfig ? JSON.parse(savedSortConfig) : defaultSortConfigUsers;
  });

  const [selectedFields, setSelectedFields] = useState(() => {
    const saved = localStorage.getItem("selectedFieldsUsers");
    return saved ? JSON.parse(saved) : defaultSelectedFieldsUsers;
  });

  const [selectionOrder, setSelectionOrder] = useState(() => {
    const saved = localStorage.getItem("selectionOrderUsers");
    return saved ? JSON.parse(saved) : defaultSelectionOrderUsers;
  });

  const [sortOrders, setSortOrders] = useState(() => {
    const saved = localStorage.getItem("sortOrdersUsers");
    return saved ? JSON.parse(saved) : defaultSortOrdersUsers;
  });
  
  const [fieldOptions, setFieldOptions] = useState([]);
  const handleSortingPopupClose = () => setShowSortingPopup(false);
  const [showSortingPopup, setShowSortingPopup] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(sortConfig.map(col => col.key));

  const [selectAll, setSelectAll] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const resetSelection = () => {
    setSelectAll(false);
    setSelectedColumns([]);
  };
  const [manageFilterOffcanvas, setManageFilterOffcanvas] = useState(false);
  const [exportmodelshow, setExportModelShow] = useState(false);
  const [excelDownload, setExcelDownload] = useState(false);

  useEffect(() => {
    if (selectedFields) {
      localStorage.setItem("selectedFieldsUsers", JSON.stringify(selectedFields));
    }
    if (selectionOrder) {
      localStorage.setItem("selectionOrderUsers", JSON.stringify(selectionOrder));
    }
    if (sortOrders) {
      localStorage.setItem("sortOrdersUsers", JSON.stringify(sortOrders));
    }
  }, [selectedFields, selectionOrder, sortOrders]);

  useEffect(() => {
    if (localStorage.getItem("role_name_User") || localStorage.getItem("company_User")) {
      const roleName = JSON.parse(localStorage.getItem("role_name_User"));
      const companyName = localStorage.getItem("company_User");

      setSelectedRole(roleName ? roleName : []);

      if (companyName) {
        const selectedCompanies = companyName?.split(",").map(item => ({
          label: item,
          value: item
        }));
        setCompanyFilterName(selectedCompanies);
      } else {
        setCompanyFilterName([]);
      }
    }
  }, []);

  useEffect(() => {
    if (manageFilterOffcanvas) {
      GetUserCompanyList();
    }
  }, [manageFilterOffcanvas]);

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      if (!manageFilterOffcanvas) {
        if (page === currentPage) {
          return;
        } else {
          GetUserList(page === null ? currentPage : JSON.parse(page), sortConfig);
        }
      }
    } else {
      navigate("/");
    }
  }, [currentPage]);

  useEffect(() => {
    if (Array.isArray(accessList)) {
      const initialCheckedState = {};
      accessList.forEach((element) => {
        initialCheckedState[element.field_name] =
          element.role_name.includes(accessRole);
      });
      setCheckedItems(initialCheckedState);
    }
  }, [accessList, accessRole]);

  useEffect(() => {
    if (localStorage.getItem("user")) {
      const userRole = JSON.parse(localStorage.getItem("user")).role;
      HandleRole("", userRole);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      getAccesslist();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    setSelectedCheckboxes(sortConfig.map(col => col.key));
  }, [sortConfig]);

  const HandleSortDetailClick = (e) => {
    setShowSort(true);
  };

  const handleSortCheckboxChange = (e, key) => {
    if (e.target.checked) {
      setSelectedCheckboxes(prev => [...prev, key]);
    } else {
      setSelectedCheckboxes(prev => prev.filter(item => item !== key));
    }
  };

  const SyestemUserRole = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).role : "";

  const handleRemoveSelected = () => {
    const newSortConfig = sortConfig.filter(item => selectedCheckboxes.includes(item.key));
    setSortConfig(newSortConfig);
    setSelectedCheckboxes([]);
  };

  const HandleRole = (e, role) => {
    if (e) {
      setRole(e.target.value);
      setAccessRole(e.target.value);
    } else {
      setRole(role);
      setAccessRole(role);
    }
  };

  const handleAccessForm = async (e) => {
    e.preventDefault();
    var userData = {
      form: accessForm,
      role: role,
      table: "users",
    };
    try {
      const data = await AdminUserRoleService.manageAccessFields(userData).json();
      if (data.status === true) {
        setManageAccessOffcanvas(false);
        setManageAccessField(true);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")));
      }
    }
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [name]: checked,
    }));
    setAccessForm((prevAccessForm) => ({
      ...prevAccessForm,
      [name]: checked,
    }));
  };

  const getAccesslist = async () => {
    try {
      const response = await AdminUserRoleService.accessField();
      const responseData = await response.json();
      setAccessList(responseData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const exportColumns = [
    { label: "First Name", key: "First Name" },
    { label: "Last Name", key: "Last Name" },
    { label: "Email", key: "Email" },
    { label: "Role", key: "Role" },
    { label: "Company", key: "Company" },
    { label: "Notes", key: "Notes" },
    { label: "Builder", key: "Builder" },
  ];

  const handleSelectAllToggle = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    if (newSelectAll) {
      setSelectedColumns(exportColumns.map(col => col.label));
    } else {
      setSelectedColumns([]);
    }
  };

  const handleColumnToggle = (column) => {
    const updatedColumns = selectedColumns.includes(column)
      ? selectedColumns.filter((col) => col !== column)
      : [...selectedColumns, column];
    setSelectedColumns(updatedColumns);
    setSelectAll(updatedColumns.length === exportColumns.length);
  };

  const handleDownloadExcel = async () => {
    setExcelDownload(true);
    let sortConfigString = "";
    if (sortConfig !== null) {
      sortConfigString = "&sortConfig=" + stringifySortConfig(sortConfig);
    }
    setExcelDownload(true);
    try {
      const roleName = JSON.parse(localStorage.getItem("role_name_User"));
      const companyName = localStorage.getItem("company_User");

      const exportPayload = {
        page: currentPage,
        sortConfig: sortConfig ? stringifySortConfig(sortConfig) : "",
        role_names: roleName ? roleName.map((role) => role.value) : selectedRole ? selectedRole.map((role) => role.value) : [],
        company: companyName ? companyName : companyFilterName || "",
        columns: selectedColumns,
      };

      const response = await AdminUserRoleService.export(exportPayload).blob();

      const downloadUrl = URL.createObjectURL(response);
      const a = document.createElement('a');

      a.href = downloadUrl;
      a.setAttribute('download', `users.xlsx`);
      document.body.appendChild(a);

      setExcelDownload(false);
      setExportModelShow(false);

      swal({
        text: "Download Completed"
      }).then((willDelete) => {
        if (willDelete) {
          a.click();
          a.parentNode.removeChild(a);
          resetSelection();
        }
      });
    } catch (error) {
      setExcelDownload(false);
      setExportModelShow(false);

      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const changeCPage = (id) => {
    setCurrentPage(id);
  };

  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const stringifySortConfig = (sortConfig) => {
    return sortConfig.map((sort) => `${sort.key}:${sort.direction}`).join(",");
  };

  const GetUserCompanyList = async () => {
    try {
      let responseData = await AdminUserRoleService.user_companies().json();
      const companyOptions = responseData?.map((item) => ({
        label: item,
        value: item,
      }));
      setCompanyOptions(companyOptions);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message)
      }
    }
  };

  const GetUserList = async (currentPage, sortConfig, reset) => {
    setIsLoading(true);
    setCurrentPage(currentPage);
    try {
      let sortConfigString = "";
      if (sortConfig !== null) {
        sortConfigString = "&sortConfig=" + stringifySortConfig(sortConfig);
      }

      const roleName = JSON.parse(localStorage.getItem("role_name_User"));
      const companyName = localStorage.getItem("company_User");

      const userData = {
        page: currentPage,
        sortConfig: sortConfig ? stringifySortConfig(sortConfig) : "",
        role_names: !reset ? roleName ? roleName?.map(role => role.value) : selectedRole?.map(role => role.value) : [],
        company: !reset ? companyName ? companyName : companyFilterName : ""
      };

      const response = await AdminUserRoleService.index(userData);

      const responseData = await response.json();
      setUserList(responseData.data);
      setNpage(Math.ceil(responseData.meta.total / recordsPage));
      setUserCount(responseData.meta.total);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const handleDelete = async (e) => {
    try {
      let responseData = await AdminUserRoleService.destroy(e).json();
      if (responseData.status === true) {
        GetUserList(currentPage, sortConfig);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const handleBulkDelete = async (id) => {
    try {
      let responseData = await AdminUserRoleService.bulkdestroy(id).json();
      if (responseData.status === true) {
        GetUserList(currentPage, sortConfig);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    }
  };

  const handleBulkStatus = async (ids) => {
    Swal.fire({
      title: "Select Active or Deactive",
      html: `
      <div style="text-align: left;">
        <label>
          <input type="radio" name="selection" value="1" checked />
          Active
        </label>
        <br />
        <label>
          <input type="radio" name="selection" value="0" />
          Deactive
        </label>
      </div>
    `,
      confirmButtonText: "Apply",
      showCancelButton: false,
      preConfirm: () => {
        const selectedOption = document.querySelector(
          'input[name="selection"]:checked'
        ).value;
        return selectedOption;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const selectedOption = result.value;
        const userData = {
          status: selectedOption, // backend expects "status"
          ids: ids,               // can be array or single id
        };

        try {
          let responseData = await AdminUserRoleService.bulk_change_status(userData);
          if (responseData.status == 200) {
            GetUserList(currentPage, sortConfig);
            Swal.fire("Success", "Status updated successfully.", "success");
            setSelectedUsers([]);
          }
        } catch (error) {
          if (error.name === "HTTPError") {
            const errorJson = error.body || { message: error.message };
            if (errorJson?.error_code === "seat_limit_reached" || errorJson?.upgrade_required) {
              showSeatLimitUpgradePrompt(errorJson.message);
              return;
            }
            setError(errorJson.message);
          } else {
            console.error("Bulk update failed:", error);
          }
        }
      }
    });
  };

  const handleCallback = () => {
    GetUserList(currentPage, sortConfig);
    setSelectedUsers([]);
  };

  const handleRowClick = async (id) => {
    setShowOffcanvas(true);
    setIsFormLoading(true);

    try {
      const responseData = await AdminUserRoleService.show(id).json();

      const userData = responseData?.data || {};

      setUserDetails(userData);
      setUserSubscriptionDetails(userData?.subscription_details || {});
      setUserCounts(userData?.user_counts || {});

    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setError(errorJson.message);
      }
    } finally {
      setIsFormLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "NA";

    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  };

  const HandleCancelFilter = () => {
    setSelectedRole([]);
    setCompanyFilterName([]);
    localStorage.removeItem("role_name_User");
    localStorage.removeItem("company_User");
    GetUserList(1, sortConfig, true);
    setManageFilterOffcanvas(false);
  };

  const HandleFilterForm = (e) => {
    e.preventDefault();
    
    const companyString = companyFilterName?.map(item => item.value).join(",");

    localStorage.setItem("role_name_User", JSON.stringify(selectedRole));
    localStorage.setItem("company_User", companyString);
    GetUserList(1, sortConfig);
    setManageFilterOffcanvas(false);
  };

  const handleOpenDialog = () => {
    setDraggedColumns(columns);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setDraggedColumns(columns);
    setOpenDialog(false);
  };

  const handleSaveDialog = () => {
    localStorage.setItem("draggedColumnsUsersList", JSON.stringify(draggedColumns));
    setColumns(draggedColumns);
    setOpenDialog(false);
  };

  const handleColumnOrderChange = (result) => {
    if (!result.destination) {
      return;
    }
    const newColumns = Array.from(draggedColumns);
    const [movedColumn] = newColumns.splice(result.source.index, 1);
    newColumns.splice(result.destination.index, 0, movedColumn);
    setDraggedColumns(newColumns);
  };

  const handleEditCheckboxChange = (e, userId) => {
    if (e.target.checked) {
      setSelectedUsers((prevSelectedUsers) => [...prevSelectedUsers, userId]);
    } else {
      setSelectedUsers((prevSelectedUsers) => prevSelectedUsers.filter((id) => id !== userId));
    }
  };

  useEffect(() => {
    const draggedColumns = JSON.parse(localStorage.getItem("draggedColumnsUsersList"));
    if (draggedColumns) {
      setColumns(draggedColumns);
    } else {
      const mappedColumns = fieldList.map((data) => ({
        id: data.charAt(0).toLowerCase() + data.slice(1),
        label: data
      }));
      setColumns(mappedColumns);
    }
  }, [fieldList]);

  const roleOptions = [
    { value: "User", label: "User" },
    { value: "Account Admin	", label: "Account Admin	" },
    { value: "Data Uploader", label: "Data Uploader" },
    { value: "Admin", label: "Admin" },
    { value: "Staff", label: "Staff" },
    { value: "Tester", label: "Tester" }

  ];

  const handleSelectRoleChange = (selectedItems) => {
    setSelectedRole(selectedItems);
  };

  const HandleCompanyFilterName = (selected) => {
    setCompanyFilterName(selected);
  };

  useEffect(() => {
    const fieldOptions = fieldList
      .filter((field) => field !== 'Action')
      .map((field) => {
        let value = field.charAt(0).toLowerCase() + field.slice(1).replace(/\s+/g, '');

        if (value === 'firstName') {
          value = 'name';
        }
        if (value === 'lastName') {
          value = 'last_name';
        }
        return {
          value: value,
          label: field,
        };
      });
    setFieldOptions(fieldOptions);
  }, [fieldList]);

  const HandleSortingPopupDetailClick = (e) => {
    setShowSortingPopup(true);
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedFields(fieldOptions);
      const newOrder = {};
      fieldOptions.forEach((field, index) => {
        newOrder[field.value] = index + 1;
      });
      setSelectionOrder(newOrder);
    } else {
      setSelectedFields([]);
      setSelectionOrder({});
    }
  };

  const handleSortingCheckboxChange = (e, field) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedFields([...selectedFields, field]);
      setSelectionOrder((prevOrder) => ({
        ...prevOrder,
        [field.value]: Object.keys(prevOrder).length + 1,
      }));
    } else {
      setSelectedFields(selectedFields.filter((selected) => selected.value !== field.value));
      setSelectionOrder((prevOrder) => {
        const newOrder = { ...prevOrder };
        delete newOrder[field.value];
        const remainingFields = selectedFields.filter((selected) => selected.value !== field.value);
        remainingFields.forEach((field, index) => {
          newOrder[field.value] = index + 1;
        });
        return newOrder;
      });
    }
  };

  const handleSortOrderChange = (fieldValue, order) => {
    setSortOrders({
      ...sortOrders,
      [fieldValue]: order,
    });
  };

  const handleApplySorting = () => {
    const sortingConfig = selectedFields.map((field) => ({
      key: field.value,
      direction: sortOrders[field.value] || 'asc',
    }));
    localStorage.setItem("sortConfigUsers", JSON.stringify(sortingConfig));
    setSortConfig(sortingConfig)
    GetUserList(currentPage, sortingConfig);
    handleSortingPopupClose();
  };

  const handleToggle = async (id, newStatus) => {
    setUserList((prev) =>
      prev.map((p) => (p.id === id ? { ...p, status: newStatus } : p))
    );

    const userData = {
      'id': id,
      'status': newStatus,
    }

    try {
      const request = await AdminUserRoleService.change_status(userData);

      if (request.status == 200) {
        swal({
          text: "Status changed successfully."
        })
      }
    } catch (error) {
      console.error("Failed to update status:", error);
      setUserList((prev) =>
        prev.map((p) => (p.id === id ? { ...p, status: !newStatus } : p))
      );

      if (error.name === "HTTPError") {
        const errorJson = error.body || { message: error.message };
        if (errorJson?.error_code === "seat_limit_reached" || errorJson?.upgrade_required) {
          showSeatLimitUpgradePrompt(errorJson.message);
          return;
        }
      }
    }
  };

  const showSeatLimitUpgradePrompt = (message) => {
    if (SyestemUserRole === "Admin" || SyestemUserRole === "Staff") {
      Swal.fire({
        text: "The account reached seat limit. Upgrade the seat plan to activate additional users.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    Swal.fire({
      text: message || "You've reached your seat limit. Upgrade your seat plan to activate additional users.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Upgrade Seats",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/subscriptionplan");
      }
    });
  };

  const confirmApprove = async (id, name, lastName) => {
    Swal.fire({
      title: "",
      html: `Do you want to approve this <b>${name} ${lastName}</b> user?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleApproveUser(id);
      }
    });
  };

  const handleApproveUser = async (id) => {
    const userData = {
      user_id: id,
    }

    try {
      const response = await AdminUserRoleService.approve_user(userData);
      const responseData = await response.json();

      if (responseData.status) {
        swal({
          text: responseData.message
        }).then(() => {
          GetUserList(currentPage, sortConfig);
        });
      }
    } catch (error) {
      console.error("Failed to approve user:", error);
    }
  };

  const handleImpersonateUser = async (user) => {
    Swal.fire({
      title: "",
      html: `Impersonate <b>${user.name} ${user.last_name || ""}</b>?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Impersonate",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) {
        return;
      }

      try {
        const data = await AdminUserRoleService.impersonate(user.id).json();
        startImpersonationSession(data);

        try {
          const subscriptionResponse = await AdminSubscriberService.getActiveSubscriptionPlan().json();
          if (subscriptionResponse.status === true) {
            updateStoredSubscriptionAccess(subscriptionResponse.data);
          }
        } catch (err) {
          console.error("Failed to fetch subscription data during impersonation", err);
        }

        navigate("/dashboard");
        window.location.reload();
      } catch (error) {
        if (error.name === "HTTPError") {
          const errorJson = await error.response.json();
          setError(errorJson.message);
          swal({ text: errorJson.message, icon: "error" });
        }
      }
    });
  };
  const DetailLine = ({ label, value }) => (
    <div className="builder-detail-line">
      <span className="builder-detail-label">{label}:</span>
      <span className="builder-detail-value">{value || "NA"}</span>
    </div>
  );

  const isValidValue = (value) => {
    return value !== null && value !== undefined && value !== "" && value !== "NA";
  };

  return (
    <Fragment>
      <MainPagetitle mainTitle="User" pageTitle="User" parentTitle="Home" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center pb-0">
                    <div className="d-flex text-nowrap justify-content-between align-items-center">
                      <h4 className="heading mb-0">User List</h4>
                      <div className="btn-group mx-5" role="group" aria-label="Basic example"></div>
                      <ColumnReOrderPopup
                        open={openDialog}
                        fieldList={fieldList}
                        handleCloseDialog={handleCloseDialog}
                        handleSaveDialog={handleSaveDialog}
                        draggedColumns={draggedColumns}
                        handleColumnOrderChange={handleColumnOrderChange}
                      />
                    </div>
                    
                    <div className="mt-2" style={{ width: "100%" }}>
                      {(SyestemUserRole == "Admin" || SyestemUserRole == "Staff") ? (
                        <div className="d-flex">
                          <button className="btn btn-primary btn-sm me-1" onClick={handleOpenDialog} title="Column Order">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-list"></i>&nbsp;
                              Column Order
                            </div>
                          </button>
                          <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={HandleSortingPopupDetailClick}
                            title="Sorted Fields"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-sort"></i>&nbsp;
                              Sort
                            </div>
                          </Button>
                          <button disabled={excelDownload || userList?.length === 0} onClick={() => setExportModelShow(true)} className="btn btn-primary btn-sm me-1" title="Export .csv">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fas fa-file-export" />&nbsp;
                              {excelDownload ? "Downloading..." : "Export"}
                            </div>
                          </button>
                          <button className="btn btn-success btn-sm me-1" onClick={() => setManageFilterOffcanvas(true)} title="Filter">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-filter" />&nbsp;
                              Filter
                            </div>
                          </button>
                          <button
                            className="btn btn-primary btn-sm me-1"
                            onClick={() => setManageAccessOffcanvas(true)}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-shield" />&nbsp;
                              Field Access
                            </div>
                          </button>
                          <Link
                            to={"#"}
                            className="btn btn-primary btn-sm me-1"
                            data-bs-toggle="offcanvas"
                            onClick={() => product.current.showEmployeModal()}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-plus" />&nbsp;
                              Add User
                            </div>
                          </Link>
                          <Link
                            to={"#"}
                            className="btn btn-primary btn-sm me-1"
                            data-bs-toggle="offcanvas"
                            onClick={() => selectedUsers?.length > 0 ? bulkproduct.current.showEmployeModal() : swal({
                              text: "Please select at least one record.",
                              icon: "warning",
                              dangerMode: true,
                            })}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-pencil" />&nbsp;
                              Edit
                            </div>
                          </Link>
                          <button
                            className="btn btn-danger btn-sm me-1"
                            onClick={() => selectedUsers.length > 0 ? swal({
                              title: "Are you sure?",
                              icon: "warning",
                              buttons: true,
                              dangerMode: true,
                            }).then((willDelete) => {
                              if (willDelete) {
                                handleBulkDelete(selectedUsers);
                              }
                            }) : ""}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-trash" />&nbsp;
                              Delete
                            </div>
                          </button>

                          <button
                            className="btn btn-primary btn-sm me-1"
                            onClick={() => selectedUsers.length > 0 ? swal({
                              title: "Are you sure?",
                              icon: "warning",
                              buttons: true,
                              dangerMode: true,
                            }).then((willDelete) => {
                              if (willDelete) {
                                handleBulkStatus(selectedUsers);
                              }
                            }) : ""}
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fas fa-user-alt-slash"></i>&nbsp;
                              Change Status
                            </div>
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <button className="btn btn-primary btn-sm me-1" onClick={handleOpenDialog} title="Column Order">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-list" />&nbsp;
                              Column Order
                            </div>
                          </button>
                          <Button
                            className="btn-sm me-1"
                            variant="secondary"
                            onClick={HandleSortingPopupDetailClick}
                            title="Sorted Fields"
                          >
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa-solid fa-sort" />&nbsp;
                              Sort
                            </div>
                          </Button>
                          {SyestemUserRole != "Tester" &&
                            <button disabled={excelDownload || userList?.length === 0} onClick={() => setExportModelShow(true)} className="btn btn-primary btn-sm me-1" title="Export .csv">
                              <div style={{ fontSize: "11px" }}>
                                <i className="fas fa-file-export" />&nbsp;
                                {excelDownload ? "Downloading..." : "Export"}
                              </div>
                            </button>
                          }
                          <button className="btn btn-success btn-sm me-1" onClick={() => setManageFilterOffcanvas(true)} title="Filter">
                            <div style={{ fontSize: "11px" }}>
                              <i className="fa fa-filter" />&nbsp;
                              Filter
                            </div>
                          </button>
                          {(SyestemUserRole == "Account Admin" || SyestemUserRole == "Account Admin & Data Uploader") && (
                            <Link
                              to={"#"}
                              className="btn btn-primary btn-sm me-1"
                              data-bs-toggle="offcanvas"
                              onClick={() => product.current.showEmployeModal()}
                            >
                              <div style={{ fontSize: "11px" }}>
                                <i className="fa fa-plus" />&nbsp;
                                Add User
                              </div>
                            </Link>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {userListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${currentPage === n ? "current" : ""
                                    } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${currentPage === n ? "current" : ""
                                  } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper custom-user no-footer"
                  >
                    {isLoading ? (
                      <div className="d-flex justify-content-center align-items-center mb-5">
                        <ClipLoader color="#4474fc" />
                      </div>
                    ) : (
                      <table
                        id="empoloyees-tblwrapper"
                        className="table ItemsCheckboxSec dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr style={{ textAlign: "center" }}>
                            <th>
                              <input
                                type="checkbox"
                                style={{
                                  cursor: "pointer",
                                }}
                                checked={selectedUsers.length === userList.length}
                                onChange={(e) =>
                                  e.target.checked
                                    ? setSelectedUsers(userList.map((user) => user.id))
                                    : setSelectedUsers([])
                                }
                              />
                            </th>
                            <th>
                              <strong>No.</strong>
                            </th>
                            {columns.map((column) => (
                              <th style={{ textAlign: "center", cursor: "pointer" }} key={column.id}>
                                <strong>
                                  {column.label}
                                  {column.id != "action" && sortConfig.some(
                                    (item) => item.key === (
                                      column.id == "builder" ? "builder" :
                                        column.id == "first Name" ? "name" :
                                          column.id == "status" ? "status" :
                                            column.id == "last Name" ? "last_name" : column.id
                                    )
                                  ) && (
                                      <span>
                                        {column.id != "action" && sortConfig.find(
                                          (item) => item.key === (
                                            column.id == "builder" ? "builder" :
                                              column.id == "first Name" ? "name" :
                                                column.id == "status" ? "status" :
                                                  column.id == "last Name" ? "last_name" : column.id
                                          )
                                        ).direction === "asc" ? "↑" : "↓"}
                                      </span>
                                    )}
                                </strong>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {userList !== null && userList.length > 0 ? (
                            userList?.map((element, index) => (
                              <tr
                                onClick={(e) => {
                                  if (e.target.type == "checkbox") {
                                    return;
                                  } else if (e.target.closest("a") || e.target.closest("button") || e.target.className == "btn btn-danger shadow btn-xs sharp" || e.target.className == "fa fa-trash" || e.target.className == "btn btn-success btn-sm me-1") {
                                    return;
                                  } else {
                                    handleRowClick(element.id);
                                  }
                                }}
                                style={{
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedUsers.includes(element.id)}
                                    onChange={(e) => handleEditCheckboxChange(e, element.id)}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  />
                                </td>
                                <td>{index + 1}</td>
                                {columns.map((column) => (
                                  <>
                                    {column.id == "status" &&
                                      <td>
                                        {element.status == 2 ?
                                          <button
                                            className="btn btn-success btn-sm me-1"
                                            onClick={() => confirmApprove(element.id, element.name, element.last_name)}
                                          >
                                            Approve
                                          </button>
                                          :
                                          <div className="form-check form-switch d-flex justify-content-center">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              role="switch"
                                              checked={element.status}
                                              onChange={(e) =>
                                                handleToggle(element.id, e.target.checked)
                                              }
                                            />
                                          </div>
                                        }
                                      </td>
                                    }
                                    {column.id == "first Name" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.name}</td>
                                    }
                                    {column.id == "last Name" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.last_name}</td>
                                    }
                                    {column.id == "email" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.email}</td>
                                    }
                                    {column.id == "role" &&
                                      // <td key={column.id} style={{ textAlign: "center" }}>{element.roles.length > 0 ? element.roles[0].name : "Admin"}</td>
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.roles.length == 2 ? element.roles[0].name + " & " + element.roles[1].name : element.roles.length == 1 ? element.roles[0].name : "NA"}</td>
                                    }
                                    {column.id == "company" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>
                                        {Array.isArray(element.company)
                                          ? element.company.map(b => b).filter(Boolean).join(", ")
                                          : element.company || "NA"
                                        }
                                      </td>
                                    }
                                    {column.id == "notes" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>{element.notes}</td>
                                    }
                                    {column.id == "builder" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>
                                        {Array.isArray(element.builder.name)
                                          ? element?.builder?.name?.map(b => b).filter(Boolean).join(", ")
                                          : element?.builder?.name ?? "NA"
                                        }
                                      </td>
                                    }
                                    {column.id == "action" &&
                                      <td key={column.id} style={{ textAlign: "center" }}>
                                        <div className="d-flex justify-content-center">
                                          <Link
                                            to={`/userupdate/${element.id}?page=${currentPage}`}
                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </Link>
                                          <Link
                                            to={`/useranalytics/${element.id}?page=${currentPage}`}
                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                          >
                                            <i className="fa-regular fa-eye"></i>
                                          </Link>
                                          {SyestemUserRole == "Admin" && !element.roles?.some((role) => role.name == "Admin") && (
                                            <button
                                              type="button"
                                              onClick={() => handleImpersonateUser(element)}
                                              className="btn btn-warning shadow btn-xs sharp me-1"
                                              title="Impersonate"
                                            >
                                              <i className="fa-solid fa-user-secret"></i>
                                            </button>
                                          )}
                                          <Link
                                            onClick={() =>
                                              swal({
                                                title: "Are you sure?",
                                                icon: "warning",
                                                buttons: true,
                                                dangerMode: true,
                                              }).then((willDelete) => {
                                                if (willDelete) {
                                                  handleDelete(element.id);
                                                }
                                              })
                                            }
                                            className="btn btn-danger shadow btn-xs sharp"
                                          >
                                            <i className="fa fa-trash"></i>
                                          </Link>

                                        </div>
                                      </td>
                                    }
                                  </>
                                ))}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" style={{ textAlign: "center" }}>
                                No data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}

                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {userListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${currentPage === n ? "current" : ""
                                    } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${currentPage === n ? "current" : ""
                                  } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <UserOffcanvas
        ref={product}
        Title="Add User"
        parentCallback={handleCallback}
      />

      <BulkUserUpdateOffcanvas
        ref={bulkproduct}
        Title={selectedUsers?.length === 1 ? "Edit User" : "Bulk Edit Users"}
        userSelectedUsers={selectedUsers}
        parentCallback={handleCallback}
      />

      <Offcanvas
        show={showOffcanvas}
        onHide={() => {
          setShowOffcanvas(false);
          clearPriceDetails();
        }}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="gridSystemModal">
            User Details
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setShowOffcanvas(false);
              clearPriceDetails();
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        {isFormLoading ? (
          <div className="d-flex justify-content-center align-items-center mt-5 mb-5">
            <ClipLoader color="#4474fc" />
          </div>
        ) : (
          <div className="offcanvas-body">
            <div className="container-fluid">
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={userDetailTab}>
                  <Box
                    sx={{
                      borderBottom: 1,
                      borderColor: "divider",
                      marginBottom: "20px",
                    }}
                  >
                    <TabList
                      onChange={handleUserDetailTabChange}
                      aria-label="user detail tabs"
                    >
                      <Tab label="Personal Details" value="personal" />
                      <Tab label="Subscription Details" value="subscription" />
                    </TabList>
                  </Box>

                  {/* Personal Details Tab */}
                  <TabPanel value="personal" className="p-0">
                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        <div className="row gy-3" style={{ fontSize: "initial" }}>
                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">First Name</label>
                            <div className="text-dark fw-semibold">
                              {UserDetails.name || "NA"}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">Last Name</label>
                            <div className="text-dark fw-semibold">
                              {UserDetails.last_name || "NA"}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">Email</label>
                            <div className="text-dark fw-semibold">
                              {UserDetails.email || "NA"}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">Role</label>
                            <div className="text-dark fw-semibold">
                              {UserDetails?.roles?.length > 0
                                ? UserDetails.roles.map((role) => role.name).join(", ")
                                : "Admin"}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <label className="fw-bold small text-muted">Company</label>
                            <div className="text-dark fw-semibold">
                              {Array.isArray(UserDetails.company)
                                ? UserDetails.company.filter(Boolean).join(", ")
                                : UserDetails.company || "NA"}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <label className="fw-bold small text-muted">Notes</label>
                            <div
                              className="border rounded p-2 text-dark"
                              style={{
                                minHeight: "120px",
                                whiteSpace: "pre-wrap",
                                background: "#fafafa",
                              }}
                            >
                              {UserDetails.notes || "NA"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  {/* Subscription Details Tab */}
                  <TabPanel value="subscription" className="p-0">
                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        <div className="row mb-4 gy-3" style={{ fontSize: "initial" }}>
                          <div className="col-md-4">
                            <div className="border rounded p-3 text-center">
                              <div className="fw-bold fs-5 text-dark">
                                {UserCounts?.total_users ?? 0}
                              </div>
                              <div className="small text-muted">Total Users</div>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="border rounded p-3 text-center">
                              <div className="fw-bold fs-5 text-success">
                                {UserCounts?.active_users ?? 0}
                              </div>
                              <div className="small text-muted">Active Users</div>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="border rounded p-3 text-center">
                              <div className="fw-bold fs-5 text-danger">
                                {UserCounts?.inactive_users ?? 0}
                              </div>
                              <div className="small text-muted">Inactive Users</div>
                            </div>
                          </div>
                        </div>

                        <div className="row gy-3" style={{ fontSize: "initial" }}>
                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">Company Name</label>
                            <div className="text-dark fw-semibold">
                              {UserSubscriptionDetails?.company_name || "NA"}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">Subscription Plan</label>
                            <div className="text-dark fw-semibold">
                              {UserSubscriptionDetails?.subscription_plan || "NA"}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">Subscription Status</label>
                            <div className="subscription-status-wrap mt-1">
                              <span
                                className={`subscription-status-badge ${
                                  UserSubscriptionDetails?.subscription_status === "active"
                                    ? "status-active"
                                    : UserSubscriptionDetails?.subscription_status === "cancelled"
                                      ? "status-cancelled"
                                      : UserSubscriptionDetails?.subscription_status === "scheduled_for_cancellation"
                                        ? "status-scheduled"
                                        : "status-default"
                                }`}
                              >
                                <span className="status-dot"></span>
                                {UserSubscriptionDetails?.subscription_status === "scheduled_for_cancellation"
                                  ? "Scheduled for Cancellation"
                                  : (UserSubscriptionDetails?.subscription_status || "NA")}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">
                              Total Allowed Users / Seats
                            </label>
                            <div className="text-dark fw-semibold">
                              {UserSubscriptionDetails?.total_allowed_users_seats ?? "NA"}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">Active Users Count</label>
                            <div className="text-dark fw-semibold">
                              {UserSubscriptionDetails?.active_users_count ?? 0}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">Inactive Users Count</label>
                            <div className="text-dark fw-semibold">
                              {UserSubscriptionDetails?.inactive_users_count ?? 0}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">
                              Subscription Start Date
                            </label>
                            <div className="text-dark fw-semibold">
                              {isValidValue(UserSubscriptionDetails?.subscription_start_date) ? (
                                <DateComponent
                                  date={UserSubscriptionDetails.subscription_start_date}
                                  subscribPaln={true}
                                />
                              ) : (
                                "NA"
                              )}
                            </div>
                          </div>

                          {isValidValue(UserSubscriptionDetails?.cancellation_requested_at) && (
                            <div className="col-md-6">
                              <label className="fw-bold small text-muted">
                                Cancellation Request Date
                              </label>
                              <div className="text-dark fw-semibold">
                                <DateComponent
                                  date={UserSubscriptionDetails.cancellation_requested_at}
                                  subscribPaln={true}
                                />
                              </div>
                            </div>
                          )}

                          <div className="col-md-6">
                            <label className="fw-bold small text-muted">
                              {UserSubscriptionDetails?.subscription_status === "scheduled_for_cancellation"
                                ? "Subscription Expiration Date"
                                : "Subscription End / Renewal Date"}
                            </label>
                            <div className="text-dark fw-semibold">
                              {isValidValue(UserSubscriptionDetails?.subscription_end_renewal_date) ? (
                                <DateComponent
                                  date={UserSubscriptionDetails.subscription_end_renewal_date}
                                  subscribPaln={true}
                                />
                              ) : (
                                "NA"
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </TabContext>
              </Box>
            </div>
          </div>
        )}
      </Offcanvas>

      <Offcanvas
        show={manageAccessOffcanvas}
        onHide={setManageAccessOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Manage User Fields Access{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setManageAccessOffcanvas(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <label className="form-label">
              Select Role:
            </label>
            <select
              className="default-select form-control"
              name="manage_role_fields"
              onChange={HandleRole}
              value={role}
            >
              <option value="Admin">Admin</option>
              <option value="Staff">Staff</option>
              <option value="Standard User">Standard User</option>
              <option value="Data Uploader">Data Uploader</option>
              <option value="Account Admin">Account Admin</option>
            </select>
            <form onSubmit={handleAccessForm}>
              <div className="row">
                {Array.isArray(accessList) &&
                  accessList.map((element, index) => (
                    <div className="col-md-4" key={index}>
                      <div className="mt-5">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={checkedItems[element.field_name]}
                            onChange={handleCheckboxChange}
                            name={element.field_name}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`flexCheckDefault${index}`}
                          >
                            {element.field_name}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <button type="submit" className="btn btn-primary mt-3">
                Submit
              </button>
            </form>
          </div>
        </div>
      </Offcanvas>

      <Modal show={showSort} onHide={HandleSortDetailClick}>
        <Modal.Header handleSortClose>
          <Modal.Title>Sorted Fields</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sortConfig.length > 0 ? (
            sortConfig.map((col) => (
              <div className="row" key={col.key}>
                <div className="col-md-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name={col.key}
                      defaultChecked={true}
                      id={`checkbox-${col.key}`}
                      onChange={(e) => handleSortCheckboxChange(e, col.key)}
                    />
                    <label className="form-check-label" htmlFor={`checkbox-${col.key}`}>
                      <span>{col.key}</span>:<span>{col.direction}</span>

                    </label>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>N/A</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSortClose}>
            cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleRemoveSelected}
          >
            Clear Sort
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Sorting */}
      <Modal show={showSortingPopup} onHide={HandleSortingPopupDetailClick}>
        <Modal.Header handleSortingPopupClose>
          <Modal.Title>Sorted Fields</Modal.Title>
          <button
            className="btn-close"
            aria-label="Close"
            onClick={() => handleSortingPopupClose()}
          ></button>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <div className="row">
            <div style={{ marginTop: "-15px" }}>
              <label className="form-label" style={{ fontWeight: "bold", fontSize: "15px" }}>List of Fields:</label>
              <div className="field-checkbox-list">
                <div className="form-check d-flex align-items-center mb-2" style={{ width: '100%' }}>
                  <div className="d-flex align-items-center" style={{ flex: '0 0 40%' }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="select-all-fields"
                      checked={selectedFields.length === fieldOptions.length}
                      onChange={handleSelectAllChange}
                      style={{ marginRight: '0.2rem', cursor: "pointer" }}
                    />
                    <label className="form-check-label mb-0" htmlFor="select-all-fields" style={{ width: "150px", cursor: "pointer" }}>
                      Select All
                    </label>
                  </div>
                </div>

                {fieldOptions.map((field, index) => {
                  const isChecked = selectedFields.some(selected => selected.value === field.value);
                  const fieldOrder = selectionOrder[field.value];

                  return (
                    <div key={index} className="form-check d-flex align-items-center mb-2" style={{ width: '100%', height: "20px" }}>
                      <div className="d-flex align-items-center" style={{ flex: '0 0 40%' }}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`field-checkbox-${index}`}
                          value={field.value}
                          checked={isChecked}
                          onChange={(e) => handleSortingCheckboxChange(e, field)}
                          style={{ marginRight: '0.2rem', cursor: "pointer" }}
                        />
                        <label className="form-check-label mb-0" htmlFor={`field-checkbox-${index}`} style={{ width: "150px", cursor: "pointer" }}>
                          {isChecked && <span>{fieldOrder}. </span>}
                          {field.label}
                        </label>
                      </div>

                      {isChecked && (
                        <div className="radio-group d-flex" style={{ flex: '0 0 60%', paddingTop: "5px" }}>
                          <div className="form-check form-check-inline" style={{ flex: '0 0 50%' }}>
                            <input
                              type="radio"
                              className="form-check-input"
                              name={`sortOrder-${field.value}`}
                              id={`asc-${field.value}`}
                              value="asc"
                              checked={sortOrders[field.value] === 'asc' || !sortOrders[field.value]}
                              onChange={() => handleSortOrderChange(field.value, 'asc')}
                              style={{ cursor: "pointer" }}
                            />
                            <label className="form-check-label mb-0" htmlFor={`asc-${field.value}`} style={{ cursor: "pointer", marginLeft: "-40px" }}>
                              Ascending
                            </label>
                          </div>
                          <div className="form-check form-check-inline" style={{ flex: '0 0 50%' }}>
                            <input
                              type="radio"
                              className="form-check-input"
                              name={`sortOrder-${field.value}`}
                              id={`desc-${field.value}`}
                              value="desc"
                              checked={sortOrders[field.value] === 'desc'}
                              onChange={() => handleSortOrderChange(field.value, 'desc')}
                              style={{ cursor: "pointer" }}
                            />
                            <label className="form-check-label mb-0" htmlFor={`desc-${field.value}`} style={{ cursor: "pointer", marginLeft: "-30px" }}>
                              Descending
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSortingPopupClose} style={{ marginRight: "10px" }}>Close</Button>
          <Button variant="success" onClick={() => handleApplySorting(selectedFields, sortOrders)}>Apply</Button>
        </Modal.Footer>
      </Modal>

      {/* Export Modal */}
      <Modal show={exportmodelshow} onHide={() => setExportModelShow(true)}>
        <Fragment>
          <Modal.Header>
            <Modal.Title>Export</Modal.Title>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => { resetSelection(); setExportModelShow(false); }}
            ></button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={10}>
                <ul className='list-unstyled'>
                  <li>
                    <label className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selectAll}
                        onChange={handleSelectAllToggle}
                      />
                      Select All
                    </label>
                  </li>
                  {exportColumns.map((col) => (
                    <li key={col.label}>
                      <label className='form-check'>
                        <input
                          type="checkbox"
                          className='form-check-input'
                          checked={selectedColumns.includes(col.label)}
                          onChange={() => handleColumnToggle(col.label)}
                        />
                        {col.label}
                      </label>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <button
              varient="primary"
              className="btn btn-primary"
              disabled={excelDownload}
              onClick={handleDownloadExcel}
            >
              {excelDownload ? "Downloading..." : "Download"}
            </button>
          </Modal.Footer>
        </Fragment>
      </Modal>

      {/* Filter Canvas */}
      <Offcanvas
        show={manageFilterOffcanvas}
        onHide={setManageFilterOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Filter User{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => { setManageFilterOffcanvas(false); setCompanyFilterName([]); setSelectedRole([]); }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <div className="">
              <form onSubmit={HandleFilterForm}>
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label className="form-label">Role:</label>
                    <MultiSelect
                      name="role"
                      placeholder={"Select Role"}
                      options={roleOptions}
                      value={selectedRole}
                      onChange={handleSelectRoleChange}
                      hasSelectAll={true}
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label className="form-label">Company:</label>
                    {/* <input type="text" value={companyFilterName} name="company" className="form-control" onChange={(e) => HandleCompanyFilterName(e.target.value)} /> */}
                    <MultiSelect
                      name="company"
                      placeholder={"Select Company"}
                      options={companyOptions}
                      value={companyFilterName}
                      onChange={HandleCompanyFilterName}
                      hasSelectAll={true}
                    />
                  </div>
                </div>
              </form>
            </div>
            <br />
            <div className="d-flex justify-content-between">
              <Button
                className="btn-sm"
                onClick={HandleCancelFilter}
                variant="secondary"
              >
                Reset
              </Button>
              <Button
                className="btn-sm"
                onClick={HandleFilterForm}
                variant="primary"
              >
                Filter
              </Button>
            </div>
          </div>
        </div>
      </Offcanvas>

      <AccessField
        tableName={"users"}
        setFieldList={setFieldList}
        manageAccessField={manageAccessField}
        setManageAccessField={setManageAccessField}
      />
    </Fragment>
  );
};

export default UserList;


